import  crypto from 'crypto'
import axios from 'axios'
import QS from 'qs'

import {setCookie,getCookie,getWebDomain,GetQueryString} from './common'
import {loginCookieName,getGlobalConstant} from './public_link'
import messageBox from '@/components/messageBox/messageBox'
import prompt from '@/components/prompt/prompt'
import {sa} from './ANALYSIS2'
let domain = getWebDomain();
let isLogerUser = false;
let globalConst = getGlobalConstant();
let userAgent = getUserAgentInit();

let openOnlyWx = getUserAgentInit()=='isWap'?(process.env.NODE_ENV=='development'?0:1):0; //无法wap打开:每日元气wap、乐享折扣
let timeOut = 8000;
if((isUserLogin()==0&&userAgent == 'isMicromessage')||(openOnlyWx==1&&getUserAgentInit()=='isWap')||getUserAgentInit()=='isPc'){
    isLogerUser = true;
    wechatLogin()
}
console.log(process.env.NODE_ENV)

/**
 * 平台参数(接口公共参数)
 * 乐纯: 1表示微信商城，2表示APP安卓，3表示PCWEB，4表示小程序，5表示wap，6表示APPIOS
 * 其他平台(可延展)
 * **/
function getPlatformId(){
    let platId = 1;

    switch (domain){
        case 'lechun.cc':
            if(userAgent == 'isMicromessage'){
                platId = 1
            }else if(userAgent == 'isWap'){
                platId = 1
            }else{
                platId = 3
            }
            break;
        case 'meiriyuanqi.com':
            if(userAgent == 'isMicromessage'){
                platId = 21
            }else if(userAgent == 'isWap'){
                platId = 25
            }else{
                platId = 23
            }
            break;
        case 'xiaobuji.com':
            if(userAgent == 'isMicromessage'){
                platId = 21
            }else if(userAgent == 'isWap'){
                platId = 25
            }else{
                platId = 23
            }
    }
    return platId
}
/**
 * 客户端设备信息
 * **/
function getUserAgentInit(){
    let userAgent = window.navigator.userAgent.toLowerCase();
    let agentState = 1;
    let mobile = !!userAgent.match(/AppleWebKit.*Mobile.*/)||!!userAgent.match(/applewebkit.*mobile.*/)||!!userAgent.match(/AppleWebkit.*mobile.*/)||!!userAgent.match(/applewebkit.*Mobile.*/);//是否为移动端
    let microMessage = userAgent.match(/MicroMessenger/i) == "micromessenger";//是否为微信
    if(mobile){
        if(microMessage){
            agentState = 'isMicromessage'
        }else{
            agentState = 'isWap'
        }
    }else{
        agentState = 'isPc'
    }
    return agentState;
}
/**
 * 微信端注册
 * **/
function wechatLogin(){
    var redict_url = encodeURI(window.location.href);
    invokeApiHttp('customer/wechatauthor',{redict_url:redict_url,state:'',scope:'snsapi_base'},'post',Math.random(),function(res){
        console.log(res)
        window.location.href = res;
    })
}
/**
 * 是否登录
 * **/
function isUserLogin(){
    let cookielogin=GetQueryString("cookielogin");
    if(cookielogin!=""){
        setCookie(loginCookieName,unescape(cookielogin));
    }
    let cookie=getCookie(loginCookieName);
    let isLogin = 0;
    if(cookie ==null){
        isLogin = 0;//未登录
    }else{
        isLogin = 1;//已登录
    }
    return isLogin;
}

/**
 * md5
 * **/
function md5Encrypt(encryptString) {
    var hasher = crypto.createHash("md5");
    encryptString = hasher.update(encryptString).digest('hex');
    return encryptString;
}

/**
 * publicApi请求方法
 * **/
function invokeApiHttp(url,data,methods,fresh,call,errorShow){

    let apiUrl,f_str,sign;
    let params={};

    apiUrl = url.replace(/(^\s*)|(\s*$)/g, "");
    data.platFormId = getPlatformId();
    data.userTerminal = getPlatformId();
    data.platformIdKey = getPlatformId();
    data.ncp_bat = GetQueryString('ncp_bat')
    f_str=JSON.stringify(data);
    f_str=f_str.split("\"").join('');
    f_str=f_str.split(" ").join('');
    f_str=f_str.replace("{","").replace("}","");
    f_str=f_str.split(",").sort().join(",");
    sign = md5Encrypt(f_str+'_'+globalConst.globalKey);

    if(fresh!=''){
        fresh = "&fresh="+ Math.random();
    }
    if(methods=='post'||methods=='POST'){
        params = {
            method:'post',
            url:apiUrl + "?sign="+sign+fresh,
            params:data,
            responseType:'json',
            withCredentials:true,
            baseURL:globalConst.globalApiUrl,
            timeout:timeOut,
        }
    }else if(methods=='POSTSPE'||methods=='postspe'){
        params = {
            method:'post',
            url:apiUrl + "?sign="+sign+fresh,
            data:QS.stringify(data),
            responseType:'json',
            withCredentials:true,
            baseURL:globalConst.globalApiUrl,
            timeout:timeOut,
        }
    }else{
        params = {
            url:apiUrl + "?sign="+sign+fresh,
            params:data,
            responseType:'json',
            withCredentials:true,
            baseURL:globalConst.globalApiUrl,
            timeout:timeOut,
        }
    }

    axios(params).then(function(response){
        if(errorShow){
            if(response.data.error_code!=null&&response.data.error_code == '20112'){
                /**
                 * 接口错误处理
                 * 20112未登录
                 * **/
                if(userAgent == 'isWap'){
                    window.location.href = '/pages/login/login.html';
                }
                if(userAgent == 'isMicromessage'){
                    setCookie(loginCookieName,'');
                    wechatLogin()
                }


                console.log(apiUrl+'-->'+response.data.error_code+'-->'+response.data.error_msg)
            }else{
                if(response.data.code == '40001'){
                    prompt(response.data.msg)
                }else{
                    call(response.data)
                }

            }
        }else{
            if(response.data.error_code!=null){
                /**
                 * 接口错误处理
                 * 20112未登录、其他错误统一弹窗:错误码+错误信息(暂时)
                 * **/
                if(response.data.error_code == '20112'){
                    if(userAgent == 'isWap'){
                        window.location.href = '/pages/login/login.html';
                    }
                    if(userAgent == 'isMicromessage'){
                        setCookie(loginCookieName,'');
                        wechatLogin()
                    }

                    console.log(apiUrl+'-->'+response.data.error_code+'-->'+response.data.error_msg)
                }else{
                    messageBox(response.data.error_msg)
                    console.log(methods+':'+apiUrl+'-->'+response.data.error_code+'-->'+response.data.error_msg)
                }
            }else{
                if(response.data.code == '40001'){
                    prompt(response.data.msg)
                }else {
                    call(response.data.value)
                }
            }
        }

    }).catch(function(error){
        /**
         * 服务器响应错误处理
         * 1、服务器响应成功返回错误(状态码不在2xx的范围内);
         * 2、请求服务之前响应错误
         * **/
        console.log(error)
        if(error.response){
            prompt('网络异常,请刷新重试');
            console.log(apiUrl+'-->'+error.response.status+'-->'+error.message)
            sa.track('newApiError',{'errorType':'异常','errorApi':apiUrl,'errorCode':error.response.status,'errorMsg':error.message});
        }else{
            prompt('网络异常,请刷新重试');
            console.log('Error',error.message);
            sa.track('newApiError',{'errorType':'超时','errorApi':apiUrl,'errorCode':'','errorMsg':error.message});
        }
        if(error.request){
            console.log(error.request)
        }
    })
}
/**
 * publicApiOld请求方法
 * **/
function invokeApiHttpOld(url,data,methods,fresh,call){
    let apiUrl,f_str,sign;
    let params={};
    apiUrl = url.replace(/(^\s*)|(\s*$)/g, "");
    data.platFormId = getPlatformId();
    data.userTerminal = getPlatformId();
    f_str=JSON.stringify(data);
    f_str=f_str.split("\"").join('');
    f_str=f_str.split(" ").join('');
    f_str=f_str.replace("{","").replace("}","");
    f_str=f_str.split(",").sort().join(",");
    sign = md5Encrypt(f_str+'_'+globalConst.globalKey);

    if(fresh!=''){
        fresh = "&fresh="+ Math.random();
    }
    if(methods=='post'||methods=='POST'){
        params = {
            method:'post',
            url:apiUrl + "?sign="+sign+fresh,
            params:data,
            responseType:'json',
            withCredentials:true,
            baseURL:globalConst.globalApiUrlOld,
            timeout:timeOut,
        }
    }else{
        params = {
            url:apiUrl + "?sign="+sign+fresh,
            params:data,
            responseType:'json',
            withCredentials:true,
            baseURL:globalConst.globalApiUrlOld,
            timeout:timeOut,
        }
    }

    axios(params).then(function(response){
        if(response.data.error_code!=null){
            /**
             * 接口错误处理
             * 20112未登录、其他错误统一弹窗:错误码+错误信息(暂时)
             * **/
            if(response.data.error_code == '20112'){
                if(userAgent == 'isWap'){
                    window.location.href = '/pages/login/login.html';
                }
                if(userAgent == 'isMicromessage'){
                    setCookie(loginCookieName,'');
                    wechatLogin()
                }
                console.log(apiUrl+'-->'+response.data.error_code+'-->'+response.data.error_msg)
            }else{

                messageBox(response.data.error_msg)
                console.log(methods+':'+apiUrl+'-->'+response.data.error_code+'-->'+response.data.error_msg)
            }
        }else{
            console.log(response.data);
            call(response)
        }

    }).catch(function(error){
        /**
         * 服务器响应错误处理
         * 1、服务器响应成功返回错误(状态码不在2xx的范围内);
         * 2、请求服务之前响应错误
         * **/
        if(error.response){
            prompt('网络超时,请刷新重试');
            console.log(apiUrl+'-->'+error.response.status+'-->'+error.message)
        }else{
            prompt('网络超时,请刷新重试');
            console.log('Error',error.message);

        }
    })
}
/**
 * publicApiUser请求方法
 * **/
function invokeApiHttpUser(url,data,methods,fresh,call){
    let apiUrl,f_str,sign;
    let params={};
    apiUrl = url.replace(/(^\s*)|(\s*$)/g, "");
    data.platFormId = getPlatformId();
    data.userTerminal = getPlatformId();
    f_str=JSON.stringify(data);
    f_str=f_str.split("\"").join('');
    f_str=f_str.split(" ").join('');
    f_str=f_str.replace("{","").replace("}","");
    f_str=f_str.split(",").sort().join(",");
    sign = md5Encrypt(f_str+'_'+globalConst.globalKey);

    if(fresh!=''){
        fresh = "&fresh="+ Math.random();
    }
    if(methods=='post'||methods=='POST'){
        params = {
            methods:'post',
            url:apiUrl + "?sign="+sign+fresh,
            params:data,
            responseType:'json',
            withCredentials:true,
            baseURL:globalConst.globalApiUrlUser,
            timeout:timeOut,
        }
    }else{
        params = {
            url:apiUrl + "?sign="+sign+fresh,
            params:data,
            responseType:'json',
            withCredentials:true,
            baseURL:globalConst.globalApiUrlUser,
            timeout:timeOut,
        }
    }

    axios(params).then(function(response){
        if(response.data.error_code!=null){
            /**
             * 接口错误处理
             * 20112未登录、其他错误统一弹窗:错误码+错误信息(暂时)
             * **/
            if(response.data.error_code == '20112'){
                if(userAgent == 'isWap'){
                    window.location.href = '/pages/login/login.html';
                }
                if(userAgent == 'isMicromessage'){
                    setCookie(loginCookieName,'');
                    wechatLogin()
                }
                console.log(apiUrl+'-->'+response.data.error_code+'-->'+response.data.error_msg)
            }else{
                messageBox(response.data.error_msg)
                console.log(methods+':'+apiUrl+'-->'+response.data.error_code+'-->'+response.data.error_msg)
            }
        }else{
            console.log(response);
            call(response)
        }

    }).catch(function(error){
        /**
         * 服务器响应错误处理
         * 1、服务器响应成功返回错误(状态码不在2xx的范围内);
         * 2、请求服务之前响应错误
         * **/
        if(error.response){
            prompt('网络超时,请刷新重试');
            console.log(apiUrl+'-->'+error.response.status+'-->'+error.message)
        }else{
            prompt('网络超时,请刷新重试');
            console.log('Error',error.message);
        }
    })
}
export const invokeApi = invokeApiHttp;
export const invokeApiOld = invokeApiHttpOld;
export const invokeApiUser = invokeApiHttpUser;

export const getQueryString = GetQueryString;
export const webLink = globalConst.globalWebLink;
export const webLinkOld = globalConst.globalWebLinkOld;
/**
 * 输出公共变量、公共方法
 * **/
export default{
    webLink:globalConst.globalWebLink,
    webLinkOld:globalConst.globalWebLinkOld,
    loginCookieName:loginCookieName,
    invokeApi:invokeApiHttp,
    getUserAgentInit:getUserAgentInit,
    invokeApiOld:invokeApiHttpOld,
    GetQueryString:getQueryString,
    getPlatformId:getPlatformId,
}
export{md5Encrypt,getUserAgentInit,loginCookieName,getPlatformId,isUserLogin}



// WEBPACK FOOTER //
// ./src/resource/js/GLOBAL2.js